import type { OEPPhase } from './phases.js';

export type OEPWindow = 'CareerStage' | 'DraftUpload' | 'Review' | 'FinalUpload' | 'Thread' | 'ThankYou' | 'Nomination' | 'Selection';

/** Which phases each write window is open in. Gates are the only thing that change phase (spec D4). */
const WINDOW_PHASES: Readonly<Record<OEPWindow, readonly OEPPhase[]>> = {
    CareerStage: ['DraftUpload'],
    DraftUpload: ['DraftUpload'],
    Review: ['Reviewing'],
    FinalUpload: ['FeedbackReleased', 'Nominating'],
    Thread: ['FeedbackReleased', 'Nominating', 'Selecting', 'Complete'],
    ThankYou: ['FeedbackReleased', 'Nominating', 'Selecting', 'Complete'],
    Nomination: ['Nominating'],
    Selection: ['Selecting'],
};

export function WindowPhases(window: OEPWindow): readonly OEPPhase[] {
    return WINDOW_PHASES[window];
}

export function IsWindowOpen(window: OEPWindow, phase: OEPPhase): boolean {
    return WINDOW_PHASES[window].includes(phase);
}
